export default __webpack_public_path__ + "static/media/ded-contact-gmail.c7d228b9.svg";